import { VStack } from "@kazaar-platform/design-system";
import { CatalogMediumBloc } from "./CatalogMediumBloc";
import { ClientReferenceBloc } from "./ClientReferenceBloc";
import { ConfigurationBloc } from "./ConfigurationBloc";
import { DeliveryBloc } from "./DeliveryBloc";
import { type OrderItemSummaryProps } from "./OrderItemSummary.types";
// import { PriceBloc } from "./PriceBloc";
import { VersionsBloc } from "./VersionsBloc";

export const OrderItemSummary = ({
  orderItem,
  onTabNavigation,
}: OrderItemSummaryProps) => {
  const sandboxItem = orderItem.sandboxItem;

  return (
    <VStack gap="sp-md">
      {/* <PriceBloc orderItem={orderItem} /> */}
      <CatalogMediumBloc sandboxItem={sandboxItem} />
      <ClientReferenceBloc orderItem={orderItem} />
      <ConfigurationBloc sandboxItem={sandboxItem} />
      <VersionsBloc
        sandboxItem={sandboxItem}
        onTabNavigation={onTabNavigation}
      />
      <DeliveryBloc orderItem={orderItem} onTabNavigation={onTabNavigation} />
    </VStack>
  );
};
